import { Component, OnInit, OnDestroy } from '@angular/core';

// Others
import Tabulator from 'tabulator-tables';
import { AdminService } from 'src/app/services/admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { WHAT } from 'src/app/shared/classes';
import { MessagesService } from '../../../services/message/messages.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalComponent } from '../../../shared/modals/base-modal/base-modal.component';
import { EventsService } from 'src/app/services/events/events.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-redeem',
  templateUrl: './redeem.component.html',
  styleUrls: ['./redeem.component.less']
})
export class RedeemComponent implements OnInit, OnDestroy {
  private table: Tabulator;
  private tableSubscription: Subscription;

  constructor(private admin: AdminService, private load: NgxSpinnerService, private msg: MessagesService, private ngbModal: NgbModal,
    private events: EventsService) { }

  ngOnInit() {
    this.load.show();

    this.initTable();

    this.getAllRedeemReferrals();

    this.listenToLoadTable();
  }

  ngOnDestroy(): void {
    this.exitPage();
  }

  // init page exit
  private exitPage() {
    this.tableSubscription.unsubscribe();
  }

  // listens to true values so that table can be reloaded with page reload
  private listenToLoadTable() {
    this.tableSubscription = this.events.getTableTriggers()
      .subscribe(triggers => {
        const from = triggers.from;
        switch (triggers.task) {
          case 'confirm':
            const redeem_id = (triggers.userData as any).referral_code;
            this.table.updateData([{ redeem_id: redeem_id, status: 'completed' }])
              .then(() => {
                this.load.hide();
              })
              .catch(err => {
                this.load.hide();
              });
            break;

          default:
            break;
        }
      }, error => {
        console.log(error);
      });
  }

  // search table
  public searchTable(searchValue) {
    const filters = [];
    const columns = this.table.getColumns();

    columns.forEach(function (column) {
      filters.push({
        field: column.getField(),
        type: 'like',
        value: searchValue,
      });
    });

    this.table.setFilter([filters]);
  }

  // inits the table
  private initTable() {
    this.table = new Tabulator('#referrals-table', {
      responsiveLayout: 'collapse',
      pagination: 'local',
      paginationSize: 15,
      paginationSizeSelector: true,
      index: 'redeem_id',
      layout: 'fitColumns',
      columns: [
        { title: 'Id', field: 'redeem_id', width: 100, visible: true, sorter: 'string' },
        { title: 'Code', field: 'refCode', width: 100, sorter: 'string' },
        { title: 'Full Name', field: 'full_name', sorter: 'string' },
        { title: 'Account No', field: 'account', sorter: 'string' },
        { title: 'Bank Name', field: 'bank_name', sorter: 'string' },
        { title: 'Amount', field: 'amount', sorter: 'string' },
        {
          title: 'Date Redeemed', field: 'date', sorter: 'date', sorterParams: {
            format: 'MMMM D YYYY, h:mm:ss A'
          }
        },
        { title: 'Status', field: 'status', sorter: 'string' },
      ],
      rowClick: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'redeem',
          data: data
        };

        // mouse click event
        this.loadModal(newData);
      },
      rowTap: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'referrals',
          data: data
        };

        // touch screen tap
        this.loadModal(newData);
      }
    });
  }

  // open modal and pass user data to it
  private loadModal(data) {
    const userModal = this.ngbModal.open(BaseModalComponent, {
      size: 'lg'
    });

    userModal.componentInstance.data = data;

    // userModal
    userModal.result
      .then((msg) => {
        if (msg.success) {
          return;
        }
      })
      .catch((msg) => {
        console.log(msg);
      });
  }

  // get all the redeems
  private getAllRedeemReferrals() {
    this.admin.GET(WHAT.RedeemList)
      .then(res => this.success(res))
      .catch(err => this.error(err));
  }

  // handle success
  private success(res) {
    this.table.addData(res);
    this.table.setSort('date', 'desc');
    this.load.hide();
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }
}
